import { CheckCircle2, XCircle } from 'lucide-react';
import type { ReactNode } from 'react';

export function Feedback({
  correct,
  label,
  title,
  children,
}: {
  correct: boolean;
  label: string;
  title?: string;
  children: ReactNode;
}) {
  return (
    <div
      role="region"
      aria-label={label}
      className={`mt-4 rounded-2xl border p-4 ${
        correct ? 'border-brand-mint/45 bg-wash-mint' : 'border-brand-coral/45 bg-wash-coral'
      }`}
    >
      <p className="flex items-center gap-2 text-sm font-extrabold text-ink">
        {correct ? (
          <CheckCircle2 className="h-4 w-4 shrink-0 text-brand-mint" aria-hidden="true" />
        ) : (
          <XCircle className="h-4 w-4 shrink-0 text-brand-coral" aria-hidden="true" />
        )}
        {title ?? (correct ? 'Correct' : 'Not yet')}
      </p>
      <div className="mt-1 space-y-1 text-sm font-medium leading-6 text-ink-soft">{children}</div>
    </div>
  );
}

export function Panel({
  eyebrow,
  title,
  description,
  children,
  label,
}: {
  eyebrow: string;
  title: string;
  description?: string;
  children: ReactNode;
  label?: string;
}) {
  return (
    <section
      aria-label={label ?? title}
      className="min-w-0 rounded-[2rem] border border-hairline bg-canvas-pure p-5 shadow-card-soft sm:p-6 lg:p-8"
    >
      <p className="text-xs font-extrabold uppercase tracking-[0.14em] text-brand-coral">{eyebrow}</p>
      <h2 className="mt-2 text-2xl font-extrabold text-ink">{title}</h2>
      {description ? <p className="mt-2 max-w-3xl font-medium leading-7 text-slate2">{description}</p> : null}
      <div className="mt-5">{children}</div>
    </section>
  );
}
